module.exports = __webpack_public_path__ + "static/img/logo-PREVENTMS2.3b214b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo-PREVENTMS2.png
// module id = Kz9I
// module chunks = 1